<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M24,12a4.357,4.357,0,0,0-2.272-3.86.25.25,0,0,1-.12-.289,4.416,4.416,0,0,0-5.459-5.46.25.25,0,0,1-.289-.12,4.416,4.416,0,0,0-7.72,0,.249.249,0,0,1-.289.12,4.416,4.416,0,0,0-5.459,5.46.249.249,0,0,1-.12.289,4.415,4.415,0,0,0,0,7.72.251.251,0,0,1,.12.29,4.416,4.416,0,0,0,5.459,5.459.25.25,0,0,1,.289.12,4.416,4.416,0,0,0,7.72,0,.249.249,0,0,1,.289-.12,4.415,4.415,0,0,0,5.459-5.459.251.251,0,0,1,.12-.29A4.354,4.354,0,0,0,24,12Zm-8.342,5.486a1.829,1.829,0,1,1,1.828-1.828A1.829,1.829,0,0,1,15.658,17.486Zm-7.829.1a1,1,0,0,1-1.411-1.411l9.753-9.753a1,1,0,1,1,1.411,1.411ZM8.343,6.514A1.829,1.829,0,1,1,6.514,8.342,1.829,1.829,0,0,1,8.343,6.514Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'discount-bubble',
    },
    name: {
      type: String,
      required: false,
      default: 'DiscountBubble',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>